'use client'

import React from 'react'
import { useApp } from '@/lib/hooks'

import Loader from '@/app/loading'

export const LoaderProvider = () => {
  const { isLoading } = useApp()

  if (isLoading) {
    return (
      <div className="fixed inset-0 z-50 bg-white">
        <Loader />
      </div>
    )
  }

  return null
}
